'use strict';

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');

var Survey = function (_Component) {
  inherits(Survey, _Component);

  function Survey(player, options) {
    classCallCheck(this, Survey);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.addChild('SurveyContainer', options);
    return _this;
  }

  Survey.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey'
    });
  };

  return Survey;
}(Component);

function sendData(question, response) {
  var HTTP = surveyPlayer.surveyOptions.api.api_post_survey.HTTP;
  var URL = surveyPlayer.surveyOptions.api.api_post_survey.URL;
  var videoId = surveyPlayer.surveyOptions.api.api_post_survey.videoId;
  var client = surveyPlayer.surveyOptions.api.api_post_survey.client;

  var params = {
    idVideo: parseInt(videoId),
    idSurvey: question.survey_id,
    //need to change
    idSubscriptionUser: 27,
    responses: [{ "id": question.id, "response": response }],
    client: client
  };
  HTTP.post(URL, params, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {
      console.log(response);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}

function getData() {
  var HTTP = surveyPlayer.surveyOptions.api.api_list_survey.HTTP;
  var URL = surveyPlayer.surveyOptions.api.api_list_survey.URL;
  var client = surveyPlayer.surveyOptions.api.api_list_survey.client;

  HTTP.get(URL, { params: { client: client } }).then(function (response) {
    if (response.data.code === 200) {
      surveyPlayer.trigger({ type: "surveyList" }, response.data);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}

var Component$1 = videojs.getComponent('Component');
var SurveyNowContent = videojs.getComponent('SurveyNowContent');
var SurveyAnsweredContent = videojs.getComponent('SurveyAnsweredContent');
var self$1 = void 0;
/**
 * survey overlay.
 */

var SurveyContainer = function (_Component) {
  inherits(SurveyContainer, _Component);

  function SurveyContainer(player, options) {
    classCallCheck(this, SurveyContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    self$1 = _this;
    _this.player = player;
    _this.options = options;
    _this.player.on("surveyList", _this.content);
    _this.getData();
    return _this;
  }

  SurveyContainer.prototype.content = function content(event, data) {
    self$1.addChild('SurveyNowContent', data);
  };

  SurveyContainer.prototype.getData = function getData$$1() {
    getData();
  };

  SurveyContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-container'
    });
  };

  return SurveyContainer;
}(Component$1);

var Component$2 = videojs.getComponent('Component');
var QuestionValidateContent = videojs.getComponent('QuestionValidateContent');

var SurveyNowContent$1 = function (_Component) {
  inherits(SurveyNowContent, _Component);

  function SurveyNowContent(player, options) {
    classCallCheck(this, SurveyNowContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;

    _this.options = options.data.survey;
    _this.questions = _this.options.questions;
    _this._createContent();
    _this.survey = null;
    return _this;
  }

  SurveyNowContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-now'
    });
  };

  SurveyNowContent.prototype._createContent = function _createContent() {

    for (var i = 0; i < this.questions.length; i++) {
      this.questions[i].survey_id = this.options.id;
      this.questions[i].validate_date = formatDate(this.options.created_at);
      this.addChild('QuestionValidateContent', this.questions[i]);
    }
    function formatDate(date) {
      var today = new Date(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = dd + '-' + mm + '-' + yyyy;
      return today;
    }
  };

  return SurveyNowContent;
}(Component$2);

var Component$3 = videojs.getComponent('Component');
var QuestionAnsweredContent = videojs.getComponent('QuestionAnsweredContent');

var SurveyAnsweredContent$1 = function (_Component) {
  inherits(SurveyAnsweredContent, _Component);

  function SurveyAnsweredContent(player, options) {
    classCallCheck(this, SurveyAnsweredContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;

    _this.options = options;
    _this.questions = options.questions.answered;
    _this._createContent();
    _this.survey = null;
    return _this;
  }

  SurveyAnsweredContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-answered'
    });
  };

  SurveyAnsweredContent.prototype._createContent = function _createContent() {
    for (var i = 0; i < this.questions.length; i++) {
      this.addChild('QuestionAnsweredContent', this.questions[i]);
    }
    //     const wrapper = document.createElement('div');
    //     var surveyBuild = `<div id="vjs-survey" class="vjs-survey">
    //     <div class="vjs-survey__top hidden-sm">
    //         <div class="vjs-survey__title" style="margin : 20px;">${this.player.localize('survey')}</div>
    //     </div>
    //
    //     <div class="vjs-survey__middle" style="width : 80%;margin:50px;">
    //     <table class="vjs-survey__content" style="overflow:auto;border: 1px solid gray;text-align: left;font-size: 1rem;background-color: rgba(255,255,255,0.3);">
    //     <tbody style="width : 100%;">
    //     <tr style="width : 100%;">
    //     <th style="width : 70%;">${this.player.localize('question')}</th>
    //     <th style="width : 10%;">${this.player.localize('yes')}</th>
    //     <th style="width : 10%;">${this.player.localize('no')}</th>
    //     <th style="width : 10%;">${this.player.localize('dont_know')}</th>
    //     </tr>`;
    //     var question;
    //     for (var i = 0; i < this.questions.length; i++) {
    //       question = `<tr>
    //     <td id="${this.questions[i].id}">${this.questions[i].question}</td>
    //     <td><input type="radio" value="1" id="check_${this.questions[i].id}" name="check_${this.questions[i].id}"/></td>
    //     <td><input type="radio" value="0" id="check_${this.questions[i].id}" name="check_${this.questions[i].id}"/></td>
    //     <td><input type="radio" value="-1" id="check_${this.questions[i].id}" name="check_${this.questions[i].id}"/></td>
    //     </tr>`
    //       surveyBuild += question;
    //     }
    //
    //     surveyBuild += `</tbody>
    // </table>
    // </div>
    //     <div class="vjs-survey__bottom" style="position : absolute;right : 20px;bottom : 20px;">
    //                 <input type="submit" tabindex="8" id="submit-form-survey" value="OK">
    //             </div>
    // </div> `
    //     wrapper.innerHTML = surveyBuild;
    //     this.el_ = wrapper.firstChild;
  };

  // _initFormExport(questions, player) {
  //   document.addEventListener('click',function(e){
  //     if(e.target && e.target.id === 'submit-form-survey'){
  //       submitFormSurvey(questions);
  //       player.getChild('SurveyOverlay').close();
  //     }
  //     });
  //   function submitFormSurvey(questions) {
  //     var responses = [];
  //     var response;
  //     var checkName;
  //     var checkNodes;
  //     var j;
  //     for (var i = 0; i < questions.length; i++) {
  //       checkName = 'check_'+questions[i].id;
  //       checkNodes = window.document.getElementsByName(checkName);
  //       j = 0;
  //       do{
  //         if(checkNodes[j].checked){
  //           response = {id : questions[i].id, response: checkNodes[j].value};
  //           responses.push(response);
  //           break;
  //         }
  //         j++;
  //       }while(j < checkNodes.length)
  //     }
  //
  //
  //     /*if (error === 0) {
  //       /*$.post(params.domain + 'sendsurvey/send_survey',
  //           {
  //               title: title,
  //               description: description,
  //               image: image,
  //               video_url: video_url,
  //               firstname: first_name,
  //               lastname: last_name,
  //               youremail: your_email,
  //               recipentemail: recipent_email,
  //               message: message,
  //               l: params.lang,
  //               fo: params.FO,
  //               c: params.client
  //           },
  //           function (data, status) {
  //               if (data.trim() === "ok") {
  //                   if(params.theme == 'vimeo') {
  //                       $(".vimeoitem.item_send_video_content .form-content").fadeOut(400, function(){
  //                           $('#input-message').val('');
  //                           $('.vimeoitem.item_send_video_content .form-content').find('input[type=text]').val('');
  //                           $(".vimeoitem.item_send_video_content .success-msg-content").fadeIn(400);
  //                       });
  //                   } else {
  //                       $(".content.form-content").fadeOut(400, function(){
  //                           $('#input-message').val('');
  //                           $('#send-video').find('input[type=text]').val('');
  //                           $(".content.success-msg-content").fadeIn(400);
  //                       });
  //                   }
  //                   setTimeout(function() { HidePopups(); }, 3000);
  //               }
  //           });
  //     }*/
  //   }
  //
  // }

  return SurveyAnsweredContent;
}(Component$3);

var Component$4 = videojs.getComponent('Component');

var QuestionAnsweredContent$1 = function (_Component) {
  inherits(QuestionAnsweredContent, _Component);

  function QuestionAnsweredContent(player, options) {
    classCallCheck(this, QuestionAnsweredContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  QuestionAnsweredContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-question-answered'
    });
  };

  QuestionAnsweredContent.prototype._createContent = function _createContent() {
    var surveyBuild = '\n<div class="vjs-survey-question-validate-content">\n<div class="vjs-survey-question-validate-header">\n<div class="vjs-survey-question-validate-date">' + this.options.validate_date + '</div>\n<span class="validate-value"> ' + this.options.ok + ' pts</span>\n</div>\n<div class="vjs-survey-question-validate-question">' + this.options.question + '</div>\n</div>\n    ';
    this.el_.innerHTML = surveyBuild;
  };

  return QuestionAnsweredContent;
}(Component$4);

var Component$5 = videojs.getComponent('Component');
var QuestionValidateContent$1 = function (_Component) {
  inherits(QuestionValidateContent, _Component);

  function QuestionValidateContent(player, options) {
    classCallCheck(this, QuestionValidateContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent(_this.options);
    return _this;
  }

  QuestionValidateContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-question-validate'
    });
  };

  QuestionValidateContent.prototype._createContent = function _createContent(options) {
    var surveyBuild = '<div class="vjs-survey-question-validate-date">' + options.validate_date + '</div>\n<div class="vjs-survey-question-validate-content">\n<div class="vjs-survey-question-validate-question">' + options.question + '</div>\n<div class="vjs-survey-question-validate-ok">\n<div class="vjs-survey-question-validate-answer">\n<input type="radio" value="1" id="check_ok_' + options.id + '" name="check_' + options.id + '"/>\n<label for="check_ok_' + options.id + '" class="radio-label">Oui </label></div>\n<img class="validate-img" src="../static/images/ok.png">\n</div>\n<div class="vjs-survey-question-validate-no">\n<div class="vjs-survey-question-validate-answer">\n<input type="radio" value="0" id="check_no_' + options.id + '" name="check_' + options.id + '"/>\n<label for="check_no_' + options.id + '" class="radio-label">Non </label></div>\n<img class="validate-img" src="../static/images/no.png">\n</div>\n<div class="vjs-survey-question-validate-answer">\n<input type="submit" tabindex="8" id="submit-form-survey_' + options.id + '" value="Envoyez">\n</div>\n</div>\n    ';

    this.el_.innerHTML = surveyBuild;
    document.addEventListener('click', clickAnswer);
    function clickAnswer(e) {
      if (e.target && e.target.id === 'submit-form-survey_' + options.id) {
        var checkBoxs = document.getElementsByName('check_' + options.id);
        if (checkBoxs[0].checked) {
          sendAnswer(options, checkBoxs[0].value);
        } else if (checkBoxs[1].checked) {
          sendAnswer(options, checkBoxs[1].value);
        }
      }
    }
    function sendAnswer(question, response) {
      sendData(question, response);
    }
  };

  return QuestionValidateContent;
}(Component$5);

// Default options for the plugin.

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  window.surveyPlayer = player;
  videojs.getComponent('Player').prototype.surveyOptions = options;
  player.addClass('vjs-videojs-survey');
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function survey
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var survey = function survey(options) {
  onPlayerReady(this, options);
};

videojs.registerComponent('Survey', Survey);
videojs.registerComponent('SurveyContainer', SurveyContainer);
videojs.registerComponent('SurveyNowContent', SurveyNowContent$1);
videojs.registerComponent('SurveyAnsweredContent', SurveyAnsweredContent$1);
videojs.registerComponent('QuestionAnsweredContent', QuestionAnsweredContent$1);
videojs.registerComponent('QuestionValidateContent', QuestionValidateContent$1);

// Register the plugin with video.js.
registerPlugin('survey', survey);

// Include the version number.
survey.VERSION = version;

module.exports = survey;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_survey/dist/videojs-survey.cjs.js
// module id = 555
// module chunks = 1